import { render, staticRenderFns } from "./Portalzugaenge.vue?vue&type=template&id=1a9a0a96"
import script from "./Portalzugaenge.vue?vue&type=script&lang=js"
export * from "./Portalzugaenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports